<template>
  <v-stepper v-model="step" style="height: 100%; overflow-y: auto">
    <v-card-title class="justify-center" style="text-align: center">
      <span>{{ $t('Bypay Summary') }}</span>
    </v-card-title>
    <v-stepper-header style="box-shadow: 0px 3px 1px 0px rgba(0, 0, 0, 0.2), 0px 2px 0px 0px rgba(0, 0, 0, 0.14), 0px 1px 0px 0px rgba(0, 0, 0, 0.12);">
      <v-stepper-step :complete="step > 1" step="1" />
      <v-divider />
      <v-stepper-step :complete="step > 2" step="2" />
      <v-divider />
      <v-stepper-step :complete="step > 3" step="3" />
      <v-divider />
      <v-stepper-step :complete="step > 4" step="4" />
      <v-divider />
      <v-stepper-step :complete="step > 5" step="5" />
      <v-divider />
      <v-stepper-step step="6" />
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <InvoiceMissingInformation v-if="firstInvoice && step === 1" :invoice="firstInvoice" :file="firstFile.originalName" :forward="!bypay" @update="nextStep" @back="backStep" />
      </v-stepper-content>

      <v-stepper-content step="2" class="pa-2 pa-sm-10">
        <ListInvoicesForCompensate v-if="firstInvoice && step === 2" :original-invoice="firstInvoice" @update="nextStep" @back="backStep" @save="saveSecondInvoice" />
      </v-stepper-content>

      <v-stepper-content step="3">
        <InvoiceMissingInformation v-if="secondInvoice && step === 3" :invoice="secondInvoice" :file="secondFile.originalName" :forward="bypay" @update="nextStep" @back="backStep" />
      </v-stepper-content>

      <v-stepper-content step="4">
        <RecordVideoCompensation v-if="step === 4" @back="backStep" @update="nextStep" @save="saveVideo" />
      </v-stepper-content>

      <v-stepper-content step="5">
        <v-card>
          <v-container fluid>
            <v-row justify="center">
              <v-col cols="12" align="center" style="font-size: 20px">
                {{ $t('CompensationSteper.Select allowed payment methods') }}.
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="12">
                <v-checkbox v-model="cryptoPayments" label="Cryptocurrency" />
                <v-checkbox v-model="outsidePlatform" label="Outside platform" />
                <v-checkbox v-model="openBanking" label="Open banking" />
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col cols="12" align="center">
                <v-btn x-large class="justify-center btn-primary" dark @click="nextStep">
                  {{ $t('Next') }}<v-icon style="margin-left: 5px">
                    mdi-arrow-right-thin
                  </v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" align="center">
                <v-btn x-large class="justify-center" color="secondary" style="color: black" @click="backStep">
                  <v-icon style="margin-right: 5px">
                    mdi-undo-variant
                  </v-icon>{{ $t('Back') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-stepper-content>
      <v-stepper-content step="6">
        <NotificationTypesForCompensate v-if="notificationData && step === 6" :notification-data="notificationData" :result-factoring="resultFactoring" @back="closeStepper" @update="closeStepper" />
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
import InvoiceMissingInformation from "@/components/InvoiceMissingInformation";
import RecordVideoCompensation from "@/components/RecordVideoCompensation";
import NotificationTypesForCompensate from "@/components/NotificationTypesForCompensate";
import ApiRepository from "@/repositories/ApiRepository";
import ListInvoicesForCompensate from "@/components/ListInvoicesForCompensate";
import Constants from "../../constants";
export default {
    name: "CompensationSteper",
    components: { InvoiceMissingInformation, ListInvoicesForCompensate, RecordVideoCompensation, NotificationTypesForCompensate },
    data () {
        return {
            cryptoPayments: true,
            outsidePlatform: true,
            openBanking: true,
            step: 1,
            loading: true,
            bypay: false,
            firstInvoice: null,
            firstFile: null,
            secondInvoice: null,
            secondFile: null,
            videoCompensation: null,
            resultFactoring: null,
            notificationData: null
        };
    },
    created () {
        this.fetch();
    },
    methods: {
        fetch () {
            if (this.$route.params.invoiceId) {
                this.$root.$emit('start-loading');
                this.loading = true;
                ApiRepository.getInvoiceById(this.$route.params.invoiceId)
                    .then((res) => {
                        if (res.data.invoice) {
                            this.firstInvoice = res.data.invoice;
                            this.bypay = this.firstInvoice && this.firstInvoice.payer && this.firstInvoice.payer._id.toString() === this.$user._id.toString();
                            this.firstFile = res.data.files[0];
                        }
                    }).finally(() => {
                        this.$root.$emit('stop-loading');
                        this.loading = false;
                    });
            }
        },
        saveSecondInvoice (event) {
            this.secondInvoice = null;
            this.secondFile = null;
            this.secondInvoice = event.invoice;
            this.secondFile = event.file;
        },
        createCompensation () {
            ApiRepository.isArchived(this.firstInvoice._id, this.$user.cif).then((res) => {
                if (res.data.isArchived) {
                    ApiRepository.unarchivateInvoice(this.firstInvoice._id, this.$user.cif);
                }
            });

            ApiRepository.isArchived(this.secondInvoice._id, this.$user.cif).then((res) => {
                if (res.data.isArchived) {
                    ApiRepository.unarchivateInvoice(this.secondInvoice._id, this.$user.cif);
                }
            });
            
            this.$root.$emit('start-loading');

            const invoiceAB = !this.bypay ? this.firstInvoice : this.secondInvoice;
            const invoiceBC = !this.bypay ? this.secondInvoice : this.firstInvoice;
            const video = this.videoCompensation ? this.videoCompensation.name : null;
            const acceptedPaymentMethods = [];

            if (this.cryptoPayments) {
                acceptedPaymentMethods.push(Constants.FACTORING_PAYMENT_METHODS.CRYPTO);
            }
            if (this.outsidePlatform) {
                acceptedPaymentMethods.push(Constants.FACTORING_PAYMENT_METHODS.OUTSIDE_PLATFORM);
            }
            if (this.openBanking) {
                acceptedPaymentMethods.push(Constants.FACTORING_PAYMENT_METHODS.OPEN_BANKING);
            }
            ApiRepository.createBypay(invoiceAB, invoiceBC, false, video, acceptedPaymentMethods).then((res) => {
                this.resultFactoring = res.data.factoring;
                this.notificationData = res.data.result;

                if (this.videoCompensation) {
                    //ApiRepository.saveVideo s'ha de passar video també
                    const extension = this.videoCompensation.name.split('.').pop().toLowerCase();
                    const file = new File([this.videoCompensation], this.resultFactoring + "." + extension, {type: this.videoCompensation.type, lastModified: new Date()});
                    ApiRepository.saveVideo(file)
                        .then(() => { })
                        .catch((err) => {
                            console.log(err);
                            this.$root.$emit('show-snackbar', {message: this.$t('Error saving video'), color: "error"});
                        });
                }
                //this.$root.$emit('show-snackbar', {message: this.$t('Saved successfully!'), color: 'success'});
            }).catch(err => {
                console.log(err);
                this.$root.$emit('show-snackbar', {message: this.$t('Error.Something went wrong'), color: 'error'});
            }).finally(() => {
                this.$root.$emit('stop-loading');
            });
        },
        nextStep () {
            if (this.step === 5) {
                this.createCompensation();
            }
            this.step = this.step !== 6 ? (this.step + 1) : this.step;
        },
        backStep () {
            if (this.step === 1) {
                this.$router.go(-1);
            } else if (this.step === 4) {
                this.step = 2;
            } else {
                this.step = this.step - 1;
            }
        },
        saveVideo (event) {
            this.videoCompensation = event.video;
        },
        closeStepper () {
            this.$root.$emit('show-snackbar', {message: this.$t('Saved successfully!'), color: 'success'});
            this.$router.push({name: 'viewInvoice', query: {invoiceId: this.firstInvoice._id}, replace: true});
        }
    }
};
</script>

<style scoped>

</style>
